/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DomesticV2InsurersInsurerIdRenterPoliciesPost201Response
 */
export interface DomesticV2InsurersInsurerIdRenterPoliciesPost201Response {
    /**
     * 
     * @type {number}
     * @memberof DomesticV2InsurersInsurerIdRenterPoliciesPost201Response
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DomesticV2InsurersInsurerIdRenterPoliciesPost201Response
     */
    'insurance_fee_cents'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DomesticV2InsurersInsurerIdRenterPoliciesPost201Response
     */
    'binding'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DomesticV2InsurersInsurerIdRenterPoliciesPost201Response
     */
    'status'?: DomesticV2InsurersInsurerIdRenterPoliciesPost201ResponseStatusEnum;
}

export const DomesticV2InsurersInsurerIdRenterPoliciesPost201ResponseStatusEnum = {
    approved: 'approved',
    denied: 'denied',
    pending: 'pending'
} as const;

export type DomesticV2InsurersInsurerIdRenterPoliciesPost201ResponseStatusEnum = typeof DomesticV2InsurersInsurerIdRenterPoliciesPost201ResponseStatusEnum[keyof typeof DomesticV2InsurersInsurerIdRenterPoliciesPost201ResponseStatusEnum];


